import React from "react";
import FavoritesPage from "../../lib/Pages/Favorites";

export default function FavsPage() {
  return <FavoritesPage />;
}
